class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = Object.create(null);
    this.requestVersion = 0;
    this.isComposing = false;
    this.renderedQuery = null;
    this.supportsPredictiveSearch = this.getPredictiveSearchSupport();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.trendingAndProductsBlock = this.querySelector('[data-quick-trending-products]');
    this.closeStickySearchButton = document.querySelector('.header-search-close');
    this.productToShow = this.dataset.productToShow;
    this.searchDetails = this.querySelector('.search_details');
    this.predictiveSearch = this.querySelector('predictive-search')
    this.isOpen = false;
    this.quickSearchTrending = this.querySelectorAll('.quickSearchTrending .link');
    this.searchResultsWidget = this.getElementsByClassName('quickSearchResultsWidget')[0];

    this.setupEventListeners();
    this.quickSearchTrending.forEach(element => {
      element.addEventListener('click', this.quickSearchTrendingClick.bind(this));
    });
  }
  
  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));
    
    this.debouncedOnChange = debounce(() => this.onChange(), 500);
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('compositionstart', () => {
      this.isComposing = true;
      this.close();
    });
    this.input.addEventListener('compositionend', () => {
      this.isComposing = false;
      this.onInput();
    });
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    document.addEventListener('click', this.onDocClick.bind(this));
    if (this.closeStickySearchButton != null) {
      this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this));
    }
    this.input.addEventListener('click', this.doBeforeQuickSearchProduct.bind(this));
    if(window.innerWidth <= 1024){
        if(document.querySelector('[data-search-mobile]')){
            document.querySelectorAll('[data-search-mobile]').forEach((button) => {
                button.addEventListener('click', this.doBeforeQuickSearchProduct.bind(this));
            });
        }
    }
  }

  doBeforeQuickSearchProduct(){
    this.renderQuickSearchProductBlock();
  }

  renderQuickSearchProductBlock(){
    if(!this.searchResultsWidget.classList.contains('ajax-loaded')){
      const block = this.searchResultsWidget.querySelector('.quickSearchProduct');

      let url = block?.getAttribute('data-collection'),
          limit = block?.getAttribute('data-limit'),
          sectionId = 'list-result-block';

      if(url != null && url != undefined) {
          $.ajax({
              type: 'GET',
              url: window.routes.root + '/collections/' + url,
              cache: false,
              data: {
                  view: 'ajax_product_block',
                  constraint: `limit=${limit}+sectionId=${sectionId}`
              },
              beforeSend: () => {
                  block.closest('.quickSearchResultsWidget').classList.add('ajax-loaded');
              },
              success: (data) => {
                  if (url != '') {
                      const dataRes = this.handleResponse(data, limit);
                      block.querySelector('.products-grid').innerHTML = dataRes;
                  }
                  window.sharedFunctions?.swapHoverVideoProductCard();
              },
              complete: () => {
                  if (typeof Currency !== 'undefined' && ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency)) {
                      let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                      Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                  }
              }
          });
      } else{
          this.searchResultsWidget.classList.add('ajax-loaded');
          if (typeof Currency !== 'undefined' && ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency)) {
              let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
              Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
          }
      }
    }
  }

  handleResponse(data,limit) {
    let htmlMedia = document.createElement('div');
    htmlMedia.innerHTML = data;

    $(htmlMedia).find(`.product:nth-child(n+${Number(limit) + 1})`).remove();
    return $(htmlMedia).html();
  }

  getQuery() {
    return this.input.value.trim();
  }

  getPredictiveSearchSupport() {
    try {
      return JSON.parse(document.getElementById('shopify-features')?.textContent || '{}').predictiveSearch !== false;
    } catch {
      return true;
    }
  }

  onInput(event) {
    this.close();
    if (this.isComposing || event?.isComposing) return;
    if (!this.getQuery().length) {
      this.close(true);
      this.showTrendingAndProducts();
      return;
    }
    this.debouncedOnChange();
  }

  onChange() {
    if (this.isComposing || document.activeElement !== this.input) return;
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) {
      this.close(true);
      return;
    }
    
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (this.isComposing || !this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();
    
    if (this.isComposing) return;
    if (!searchTerm.length) return this.showTrendingAndProducts();

    if (this.getAttribute('results') === 'true' && this.renderedQuery === searchTerm) {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
        // this.hideTrendingAndProducts();
      };
    })
  }
  
  onKeyup(event) {
    if (this.isComposing || event.isComposing || event.keyCode === 229) return;
    if (!this.getQuery().length) {
      this.close(true);
      this.showTrendingAndProducts();
    };
    event.preventDefault();
    
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (this.isComposing || event.isComposing || event.keyCode === 229) return;
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.hasAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = Array.from(this.predictiveSearchResults.querySelectorAll('[role="option"]'));
    if (!allElements.length) return;
    let activeElement = allElements[0];

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';
    
    if (!moveUp && selectedElement) {
      activeElement = allElements[(allElements.indexOf(selectedElement) + 1) % allElements.length];
    } else if (moveUp) {
      activeElement = allElements[(allElements.indexOf(selectedElement) - 1 + allElements.length) % allElements.length];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
    
  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }
  
  async getSearchResults(searchTerm) {
    this.abortController?.abort();
    const controller = new AbortController();
    this.abortController = controller;
    const requestVersion = ++this.requestVersion;
    const queryKey = searchTerm;
    this.setLiveRegionLoadingState();

    try {
      let resultsMarkup = this.cachedResults[queryKey];
      if (!resultsMarkup) {
        const searchUrl = this.getSearchUrl(searchTerm, true);
        const limit = Math.min(10, Math.max(1, Number(this.productToShow) || 3));
        const predictiveUrl = `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=product&resources%5Blimit%5D=${limit}&section_id=predictive-search`;
        let response = await fetch(this.supportsPredictiveSearch ? predictiveUrl : searchUrl, { signal: controller.signal });
        if (response.status === 417 && this.supportsPredictiveSearch) {
          this.supportsPredictiveSearch = false;
          response = await fetch(searchUrl, { signal: controller.signal });
        }
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const text = await response.text();
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        if (!section?.querySelector('[data-predictive-search-live-region-count-value]')) throw new Error('Search results are unavailable');
        resultsMarkup = section.innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
      }
      if (!this.isCurrentRequest(searchTerm, requestVersion)) return;
      this.renderedQuery = searchTerm;
      this.renderSearchResults(resultsMarkup);
      await this.updateViewAllLink(searchTerm, requestVersion, controller.signal);
    } catch (error) {
      if (error.name !== 'AbortError' && this.isCurrentRequest(searchTerm, requestVersion)) {
        this.close();
      }
    }
  }

  isCurrentRequest(searchTerm, requestVersion) {
    return requestVersion === this.requestVersion && searchTerm === this.getQuery() && !this.isComposing && document.activeElement === this.input;
  }

  getSearchUrl(searchTerm, section = false) {
    return `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&options%5Bprefix%5D=last&type=product${section ? '&section_id=predictive-search' : ''}`;
  }
  
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setAttribute('open', true);
    this.setLiveRegionResults();
    this.open();
    this.hideTrendingAndProducts();
    if (typeof Currency !== 'undefined' && ((window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency)) {
      Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
    }
    window.sharedFunctions?.swapHoverVideoProductCard();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('[class^="header-navigation"]').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  
  open() {
    //this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.abortController?.abort();
    this.requestVersion += 1;
    this.removeAttribute('loading');
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.renderedQuery = null;
    }
    
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }

  showTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 
    this.trendingAndProductsBlock.classList.add('is-show')
    this.trendingAndProductsBlock.classList.remove('hidden');
  }

  hideTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 

    this.trendingAndProductsBlock.classList.remove('is-show')
    this.trendingAndProductsBlock.classList.add('hidden');
  }

  onDocClick(e) {
    const isInModal = this.contains(e.target), $target = e.target

    if (!isInModal || $target.closest('.header-search-popup-close') || $target.matches('.header-search-popup-close') || $target.closest('.header-search-close') || $target.matches('.header-search-close')) {
      this.close();
      this.hideTrendingAndProducts();
    }
  }

  onCloseStickySearchClick() {
    this.close();
    this.hideTrendingAndProducts();
    document.querySelector('body').classList.remove('sticky-search-open');
    document.querySelector('body').classList.remove('sticky-search-menu-open');
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-open')
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-custom-open')
  }

  async updateViewAllLink(searchTerm, requestVersion, signal) {
    const qsViewAllLink = this.predictiveSearchResults.querySelector('[data-qs-view-all-link]');
    if (!qsViewAllLink) return;
    qsViewAllLink.href = this.getSearchUrl(searchTerm);
    if (this.predictiveSearchResults.querySelector('[data-search-result-count]')) return;

    try {
      const response = await fetch(this.getSearchUrl(searchTerm, true), { signal });
      if (!response.ok) return;
      const text = await response.text();
      const count = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-search-result-count]')?.dataset.searchResultCount;
      if (count !== undefined && this.isCurrentRequest(searchTerm, requestVersion)) {
        qsViewAllLink.textContent = qsViewAllLink.dataset.countLabel.replace('__COUNT__', count);
      }
    } catch (error) {
      if (error.name !== 'AbortError') this.removeAttribute('loading');
    }
  }

  quickSearchTrendingClick(event) {
    window.location = event.currentTarget.getAttribute('href');
  }
}

customElements.define('predictive-search', PredictiveSearch);
